<template>
  <header>
    <div :class="['sair', { 'hide': hide }]">
      <span
        class="button-sair"
        @click="sair()"
      >sair</span>
    </div>
    <div class="banner">
      <h1 class="titulo-banner">
        Conheça os benefícios do seu plano de saúde
      </h1>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    sair() {
      this.$emit('sair');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
